import { render, staticRenderFns } from "./ProductEditViewModal.vue?vue&type=template&id=1f54cac4&"
import script from "./ProductEditViewModal.vue?vue&type=script&lang=js&"
export * from "./ProductEditViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditViewModal.vue?vue&type=style&index=0&id=1f54cac4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports